const getBackToUrl = (
  searchParams: URLSearchParams,
  teamId: string,
  campaignId: string,
): string | undefined => {
  if (searchParams.get('mode') === 'new') {
    return `/${teamId}/campaign/${campaignId}/key-details`;
  }
  return undefined;
};

export default getBackToUrl;
